import { request } from 'data/requests/request';

export interface ICustomerAuthStatus {
    id: number;
    name: string;
    email: string;
}

export interface ICustomerAuthStatusResponse {
    isLoggedIn: boolean;
    customer?: ICustomerAuthStatus;
}

export const customerAuthStatusRequest = () =>
    request({
        type: 'customerAuthStatusRequest',
        url: 'authentication/ajax/authstatus',
        method: 'GET',
        notApi: true,
        absolute: false,
    });
